import Icon from '../../../common/icons/Icon.js'

export default function InternalNotesPopOver({internalNotes}) {
  if (!internalNotes) {
    return null
  }

  return (
    <div className="wrap--pop-over">
      <Icon name="internal-note" className="icon--pop-over op-50 fs-00" />
      <dl className="pop-over pop-over--right">
        <dt className="pop-over__title">Internal Notes</dt>
        <dd className="pop-over__body">
          <p className="fs-n1 lh-md margin-bottom-0">{internalNotes}</p>
        </dd>
      </dl>
    </div>
  )
}
